// Configuración de Tracking - Reemplazar con valores reales cuando estén disponibles

export const TRACKING_CONFIG = {
  // Google Tag Manager
  GTM_ID: process.env.REACT_APP_GTM_ID || 'GTM-XXXXXXX',

  // Google Analytics 4
  GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX',

  // Facebook Pixel
  FB_PIXEL_ID: process.env.REACT_APP_FB_PIXEL_ID || 'XXXXXXXXXX',

  // Configuración adicional
  ENABLE_TRACKING: process.env.NODE_ENV === 'production',
  DEBUG_MODE: process.env.NODE_ENV === 'development',
} as const;

// Tipos para TypeScript
export type TrackingEventType =
  | 'page_view'
  | 'form_view'
  | 'form_start'
  | 'form_submit'
  | 'form_error'
  | 'cta_click'
  | 'scroll'
  | 'time_on_page';

export type FormType = 'hero' | 'final' | 'demo' | 'trial';
export type SourceType =
  | 'landing-larga'
  | 'landing-corta'
  | 'hero-form'
  | 'final-cta-form';

// Interfaces para eventos de tracking
export interface BaseTrackingEvent {
  event: TrackingEventType;
  timestamp: string;
  source: SourceType;
  user_agent?: string;
  page_url: string;
}

export interface FormTrackingEvent extends BaseTrackingEvent {
  event: 'form_view' | 'form_start' | 'form_submit' | 'form_error';
  form_type: FormType;
  form_field?: string;
  error_type?: string;
  lead_data?: {
    name: string;
    email: string;
    phone: string;
    restaurant: string;
  };
}

export interface CTATrackingEvent extends BaseTrackingEvent {
  event: 'cta_click';
  cta_type: string;
  cta_text: string;
  cta_position: string;
}

export interface PageViewTrackingEvent extends BaseTrackingEvent {
  event: 'page_view';
  page_name: string;
  page_title: string;
  referrer?: string;
}

// Función helper para validar configuración
export const validateTrackingConfig = (): boolean => {
  const { GTM_ID, GA_MEASUREMENT_ID, FB_PIXEL_ID } = TRACKING_CONFIG;

  const hasValidGTM = Boolean(GTM_ID && GTM_ID !== 'GTM-XXXXXXX');
  const hasValidGA = Boolean(
    GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX'
  );
  const hasValidFB = Boolean(FB_PIXEL_ID && FB_PIXEL_ID !== 'XXXXXXXXXX');

  if (TRACKING_CONFIG.DEBUG_MODE) {
    console.log('Tracking Configuration:', {
      GTM_ID: hasValidGTM ? '✅ Configured' : '❌ Not configured',
      GA_MEASUREMENT_ID: hasValidGA ? '✅ Configured' : '❌ Not configured',
      FB_PIXEL_ID: hasValidFB ? '✅ Configured' : '❌ Not configured',
      ENABLE_TRACKING: TRACKING_CONFIG.ENABLE_TRACKING,
      DEBUG_MODE: TRACKING_CONFIG.DEBUG_MODE,
    });
  }

  return hasValidGTM || hasValidGA || hasValidFB;
};
